import { AODA } from "@core/utilities/aoda";
import {
  Component,
  ElementRef,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { BaseComponent } from "@shared/components/base.component";
import { FormGroup } from "@angular/forms";
import { startWith, takeWhile, filter, switchMap, exhaustMap, tap } from "rxjs/operators";
import { ElasticsearchQueryService } from "@shared/services/elasticsearch-query.service";
import { Utils } from "@core/utilities/utils";
import {  } from '@angular/cdk/scrolling';
import { Observable, of, Subject } from "rxjs";

@Component({
  selector: "app-nts-filter",
  templateUrl: "./nts-filter.component.html",
  styleUrls: ["./nts-filter.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class NtsFilter extends BaseComponent implements OnInit, OnDestroy {
  @Input() f: FormGroup;
  @Input() clearFilter: boolean;
  @Input() enableFilter: boolean;
  displayNtsFilter: boolean = false;
  public height: string;
  totalFilterValues: number = 0;

  //Auto-Complete Variables
  lastViewedPage: number;
  lastFilter = "";
  ntsList: any[] = [];
  selectedNts: any[] = new Array<any>();
  filteredNts: any[];
  isAllSelected = false;
  isInitialized = false;
  filteredNts$: Observable<any[]> | undefined;
  private nextPage$ = new Subject();

  constructor(
    private injector: Injector,
    private el: ElementRef,
    private r2: Renderer2,
    private searchFiltersService: ElasticsearchQueryService
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();

    if(this.f.get("nts").value.length > 0) {
      this.displayNtsFilter = true;
      this.makeNtsRequest();
    } else {
      this.displayNtsFilter = false;
    }

    this.selectedNts = this.f.get("nts").value;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  ngAfterViewInit(): void {
    AODA.applyAllFixes(this.el, this.r2, this.languageService.languageType);
  }

  ngOnChanges() {
    //Reset the last viewed page if click outside NTS filter area
    this.r2.listen('window', 'click',(e:Event)=>{
      this.lastViewedPage = 1;
      this.tempNts.setValue("");
      this.getObservableValues();
    });

    if (this.clearFilter) {
      this.unselectAll();
      this.clearFilter = false;
    }

    if (!this.enableFilter) {
      this.displayNtsFilter = false;
    }
  }

  getNtsList(startsWith: any, page: number): Observable<any[]> {
    const take = 10;
    const skip = page > 0 ? (page - 1) * take : 0;
    const filtered = this.ntsList.filter((option) =>
      option._source.nts_num.toLowerCase().startsWith(startsWith)
    );
    this.lastViewedPage = page;
    return of(filtered.slice(0, skip + take));
  }

  displayWith(element: any) {
    return element ? element.nts_num : null;
  }

  onScroll() {
    this.nextPage$.next(null);
  }

  //Filter Functions
  onDisplayNtsFilter() {
    if (this.enableFilter) {
      if (!this.displayNtsFilter && !this.isInitialized) {
        this.makeNtsRequest();
      }
      this.displayNtsFilter = !this.displayNtsFilter;
    }
  }

  makeNtsRequest() {
    this.isInitialized = true;
    this.searchFiltersService
      .getNts()
      .pipe(takeWhile(() => this.alive))
      .subscribe((nts) => {
        this.totalFilterValues = nts.hits.hits.length;
        this.ntsList = this.filteredNts = Utils.sortElasticSearchFilterList(
          nts.hits.hits,
          "nts_num"
        );
        this.getObservableValues();
      });
  }

  getObservableValues() {
    const filter$ = this.tempNts.valueChanges.pipe(
      startWith(""),
      filter((q) => typeof q === "string")
    );

    this.filteredNts$ = filter$.pipe(
      switchMap((filter) => {
        let currentPage = this.lastViewedPage;
        return this.nextPage$.pipe(
          startWith(currentPage),
          exhaustMap((_) => this.getNtsList(filter, currentPage)),
          tap(() => currentPage++)
        );
      })
    );
  }
  //Filter Functions

  //Auto-Complete
  isNtsChecked(item: any) {
    if (this.isSelected(item)) {
      item.selected = true;
      return true;
    }
    item.selected = false;
    return false;
  }

  isSelected(item: any): boolean {
    return this.nts.value.includes(item._source.nts_num);
  }

  updateAllSelected() {
    return (this.isAllSelected =
      this.nts.value.length == this.totalFilterValues ? true : false);
  }

  toggleSelectAll(event: any) {
    //Needed for mat-option and mat-checkbox
    if (event.isUserInput || event.source._currentCheckState) {
      this.isAllSelected = !this.isAllSelected;
      this.selectedNts = [];

      for (let i = 0; i < this.ntsList.length; i++) {
        this.ntsList[i].selected = this.isAllSelected;

        if (this.isAllSelected) {
          this.selectedNts.push(this.ntsList[i]._source.nts_num);
        }
      }
      this.updateNts(this.selectedNts);
    }
  }

  unselectAll() {
    for (let i = 0; i < this.ntsList.length; i++) {
      this.ntsList[i].selected = false;
    }
    this.selectedNts = [];
    this.updateNts(this.selectedNts);
  }

  toggleSelection(item: any, event: any) {
    //Needed for mat-option and mat-checkbox
    if (event.isUserInput || event.source._currentCheckState) {
      item.selected = !item.selected;
      if (item.selected && !this.isSelected(item)) {
        this.selectedNts.push(item._source.nts_num);
      } else {
        const i = this.selectedNts.findIndex(
          (value) => value === item._source.nts_num
        );
        this.selectedNts.splice(i, 1);
      }
      this.updateNts(this.selectedNts);
    }
  }

  updateNts(arr: any[]) {
    var ntsList = [];
    for (var i = 0; i < arr.length; i++) {
      ntsList.push(arr[i]);
    }
    this.nts.setValue(ntsList);
  }
  //Auto-Complete

  get nts() {
    return this.f.get("nts");
  }

  get tempNts() {
    return this.f.get("tempNts");
  }
}
